import React from 'react';
import ReactHtmlParser from '@orrisroot/react-html-parser';

import PopupModal from 'components/PopupModal/PopupModal';
import { CoverItem } from 'types/expiryRenewal';

type CoverItemModalProps = {
  // The content row's own modal copy - "link" doubles as the heading, as the CMS sends it.
  modal: CoverItem['modal'];
  onClose: () => void;
};

/**
 * The "features and exclusions" detail behind a line of cover content. The extras the
 * member can drop and the ones they cannot are laid out differently but explain themselves
 * identically, so the popup is shared and each list keeps its own idea of which row is open.
 */
const CoverItemModal = ({ modal, onClose }: CoverItemModalProps) => (
  <PopupModal
    resultTitle={ReactHtmlParser(modal?.link ?? '')}
    resultText={ReactHtmlParser(modal?.text ?? '')}
    action={onClose}
    displayDialogInMiddle
    innerCloseButton
  />
);

export default CoverItemModal;
